export default class Module {
	constructor(name, contents) {
		this.name = name;
		this.contents = contents;
	}
}